'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFireAlarm from 'UIComponents/alert/UIFireAlarm';
import ResendVerificationEmailButton from './ResendVerificationEmailButton';
import { EMAIL_CONFIRM_ACTIONS_ID, HUBSPOT_EMAIL_CONFIRM_BAR_ID } from '../constants/DOMSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailConfirmBarTemplate = email => /*#__PURE__*/_jsxs(UIFireAlarm, {
  type: "info",
  use: "inline",
  id: HUBSPOT_EMAIL_CONFIRM_BAR_ID,
  children: [/*#__PURE__*/_jsx("p", {
    className: "display-inline",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "emailConfirmBar.title",
      options: {
        email
      }
    })
  }), ' ', /*#__PURE__*/_jsx("div", {
    className: "display-inline",
    id: EMAIL_CONFIRM_ACTIONS_ID,
    children: ResendVerificationEmailButton()
  })]
});
export default EmailConfirmBarTemplate;